import React, { useMemo } from 'react';
import Card from '../../components/Card';
import Button from '../../components/Button';
import Currency from '../../components/Price';
import { useStateContext } from '../../context/StateContext';
import { CUSTOM_PAYMENT_PROVIDER, STEPS } from '../../utils/constants';
import style from './payment-info.module.scss';

const PaymentInfo = ({ onContinueClick }) => {
	const { state } = useStateContext();
	const { pageSettings: { providerId, useFastPay } = {}, overview: { totalPaymentPrice } = {}, currentStep } = state;
	const isResultStep = useMemo(() => currentStep === STEPS.RESULT, [currentStep]);
	const isPaymentStep = useMemo(() => currentStep === STEPS.PAYMENT, [currentStep]);
	const isCustomProvider = useMemo(() => providerId === CUSTOM_PAYMENT_PROVIDER, [providerId]);
	const fastPayWithForm = useFastPay && !isCustomProvider;

	const showContainer = !isResultStep && (
		fastPayWithForm
		|| (!isPaymentStep && !useFastPay)
		|| (isPaymentStep && !isCustomProvider)
	);

	return showContainer ? (
		<Card className={style.container} customContentClass={style.content} title="Ödeme özeti">
			<div className={style.payment}>
				<p className={style.title}>Ödenecek tutar</p>
				<Currency className={style.price} value={totalPaymentPrice}/>
			</div>
			<Button name={currentStep === 0 ? 'Devam et': 'Ödeme yap'} onClick={() => totalPaymentPrice > 0 && onContinueClick?.()}/>
		</Card>
	) : <div className={style.container} />;
};

export default PaymentInfo;
